
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-conditions-of-order",
      function () {
        return require("private-next-pages/terms-conditions-of-order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-conditions-of-order"])
      });
    }
  